import {
  useSpecsTranslation,
  useUnitTranslation
} from "../../hooks/TranslationHooks";

const SpecsSummary = ({ specsIndexed }) => {
  const ts = useSpecsTranslation();
  const tu = useUnitTranslation();

  return (
    !!specsIndexed && (
      <div style={{ fontSize: "0.85em" }}>
        {Object.entries(specsIndexed).map(([field, { value, unit, note }]) => {
          const fld = field.split("_")[0];
          return (
            <div key={field}>
              <strong>{ts(fld) + ":"}</strong>
              {" " + ts(fld, value)} {unit && tu(unit)}
              {note ? <span className="spec-note">({note})</span> : ""}
            </div>
          );
        })}
      </div>
    )
  );
};

export default SpecsSummary;
